import { useEffect } from "react"

const ufx = useEffect

// runs useEffect callback only once when a component is mounted
// works around the ESLint rule about the exhaustive dependency list
export const useMountEffect = (fun: React.EffectCallback) => ufx(fun, [])
